import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
} from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { ExclamationCircleOutlined, TeamOutlined } from '@ant-design/icons';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import Link from 'antd/lib/typography/Link';
import { useConnection } from '../../../../connection/Application';
import {
  DataTable,
  DataTableColumns,
  DataTablePagination,
} from '../../../../components/molecules/DataTable/DataTable';
import { Employee } from '../../../../entity/Employee';
import { UserAvatar } from '../../../../components/atoms/UserAvatar';
import { AutoCompleteInput } from '../../../../form/adapters/AutoCompleteInput';
const { confirm } = Modal;

const columns2: DataTableColumns<Employee> = [
  {
    title: 'Avatar',
    dataIndex: 'image',
    key: 'image',
    // eslint-disable-next-line react/display-name
    render: (value) => <UserAvatar src={value} />,
  },
  {
    title: 'First Name',
    dataIndex: 'firstName',
    key: 'firstName',
  },
  {
    title: 'Last Name',
    dataIndex: 'lastName',
    key: 'lastName',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  // {
  //   title: 'Employee Id',
  //   dataIndex: 'employeeId',
  //   key: 'employeeId',
  // },
  // {
  //   title: 'Type',
  //   dataIndex: 'type',
  //   render: (value) =>
  //     value.type === 'user' ? (
  //       <Typography>User</Typography>
  //     ) : value.type === 'teamLead' ? (
  //       <Typography>Team Lead</Typography>
  //     ) : (
  //       <Typography>Team Member</Typography>
  //     ),
  // },
  // {
  //   title: 'Supervisor',
  //   dataIndex: 'supervisorName',
  //   key: 'supervisorName',
  //   display: 'lg',
  // },
  // {
  //   title: 'Teams',
  //   dataIndex: 'supervisor',
  //   key: 'supervisor',
  //   display: 'lg'
  //   // render:teams=>{

  //   // }
  // }
];

export const UserGroup: FC = () => {
  const params = useParams<{ cycle: string; id: string; name: string }>();
  const history1 = useHistory();
  const connection = useConnection();
  const [teamSet, setTeamSet] = useState<any[]>([]);
  const [userSet, setUserSet] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [fetch, setFetch] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [userGroupTeamMembers, setUserGroupTeamMembers] = useState<any[]>([]);
  const [userGroupTeamLeaders, setUserGroupTeamLeaders] = useState<any[]>([]);
  const [teams, setTeams] = useState<any[]>([]);
  const [userGroupUser, setUserGroupUsers] = useState<any[]>([]);
  const [userGroupType, setUserGroupType] = useState<'teamMember' | 'teamLead' | 'user'>();
  const [internalCustomerIds, setInternalCustomerIds] = useState<number[]>([]);
  const [internalCustomerIds1, setInternalCustomerIds1] = useState<number[]>([]);
  const [selectedValue, setSelectedValue] = useState<any>();
  const [tableDate, setTableData] = useState<any[]>([]);
  const [pagination, setPagination] = useState<DataTablePagination>({ page: 1, size: 10 });
  const [total, setTotal] = useState<number>(0);

  const columns = useMemo(() => {
    return [
      {
        title: 'Group Members',
        dataIndex: 'internalCustomerName',
        key: 'internalCustomer',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <div>
            <Link
              onClick={() => {
                setUserGroupType(record.type);
                if (record.type == 'user')
                  setSelectedValue({ id: record?.entityId, value: record?.name });
                setModalVisible(true);
              }}>
              {text}
            </Link>
          </div>
        ),
      },
    ];
  }, []);

  const columns1 = useMemo(() => {
    return [
      {
        title: 'Group Members',
        dataIndex: 'internalCustomerName',
        key: 'internalCustomer',
        // eslint-disable-next-line react/display-name
        render: (text: string) => (
          <div>
            <Link>{text}</Link>
          </div>
        ),
      },
      {
        title: 'Selection',
        dataIndex: 'entityId',
        key: 'entityId',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <div>
            <Checkbox
              defaultChecked={record.teamMember}
              onChange={() => {
                if (record.teamMember) {
                  let internalUsers: any[] = [];
                  let internalTeamLead: any[] = [];
                  let internalTeamMember: any[] = [];
                  internalTeamMember = userGroupTeamMembers.filter(
                    (item) => item?.entityId !== record?.entityId,
                  );
                  internalTeamLead = userGroupTeamLeaders;
                  internalUsers = userGroupUser;

                  const users: any[] = [];
                  for (const item of internalUsers) {
                    users.push({
                      entityId: item?.entityId,
                      type: 'user',
                    });
                  }
                  for (const item of internalTeamMember) {
                    users.push({
                      entityId: item?.entityId,
                      type: 'teamMember',
                    });
                  }
                  for (const item of internalTeamLead) {
                    users.push({
                      entityId: item?.entityId,
                      type: 'teamLead',
                    });
                  }
                  connection
                    .patch(`user-group/${params.id}/members`, {
                      users,
                    })
                    .then(() => {
                      setFetch(!fetch);
                      setLoading(false);
                      setSelectedValue(undefined);
                      setModalVisible(false);
                    });
                } else {
                  setCustomValues(record, 'teamMember');
                }
              }}>
              Team Members
            </Checkbox>
            <Checkbox
              defaultChecked={record.teamLead}
              onChange={() => {
                if (record.teamLead) {
                  let internalUsers: any[] = [];
                  let internalTeamMember: any[] = [];
                  let internalTeamLead: any[] = [];
                  internalTeamLead = userGroupTeamLeaders.filter(
                    (item) => item?.entityId !== record?.entityId,
                  );
                  internalTeamMember = userGroupTeamMembers;
                  internalUsers = userGroupUser;
                  const users: any[] = [];
                  for (const item of internalUsers) {
                    users.push({
                      entityId: item?.entityId,
                      type: 'user',
                    });
                  }
                  for (const item of internalTeamMember) {
                    users.push({
                      entityId: item?.entityId,
                      type: 'teamMember',
                    });
                  }
                  for (const item of internalTeamLead) {
                    users.push({
                      entityId: item?.entityId,
                      type: 'teamLead',
                    });
                  }
                  connection
                    .patch(`user-group/${params.id}/members`, {
                      users,
                    })
                    .then(() => {
                      setFetch(!fetch);
                      setLoading(false);
                      setSelectedValue(undefined);
                      setModalVisible(false);
                    });
                } else {
                  setCustomValues(record, 'teamLead');
                }
              }}>
              Team Leaders
            </Checkbox>
          </div>
        ),
      },
    ];
    // eslint-disable-next-line
  }, [connection, fetch, params.id, userGroupTeamLeaders, userGroupTeamMembers, userGroupUser]);

  useEffect(() => {
    setLoading(true);
    connection
      .get(`user-group/${params.id}`)
      .then(
        (res: {
          teams: any[];
          users: any[];
          members: Employee[];
          userGroup: any;
          total: number;
        }) => {
          setTeamSet(res.teams);
          setUserSet(res.users);
          setTableData(res?.members);
          setTotal(res?.total);
          // setInternalValue(goalSummary?.internalCustomerCriteriaSetId ?? 0);
          const dataArr: any[] = [];
          const dataArr1: any[] = [];

          for (const item of res.userGroup?.user ?? []) {
            dataArr1.push({
              ...item,
              key: item?.id,
              internalCustomerName: item?.name,
              type: item.type,
            });
          }
          for (const item of res.userGroup?.team ?? []) {
            dataArr.push({
              ...item,
              key: item?.id,
              internalCustomerName: item?.name,
              type: item.type,
            });
          }
          setUserGroupTeamMembers(dataArr.filter((e) => e.teamMember));
          setUserGroupTeamLeaders(dataArr.filter((e) => e.teamLead));
          setTeams(dataArr);
          setUserGroupUsers(dataArr1);
          setInternalCustomerIds(dataArr.map((item) => item.entityId));
          setInternalCustomerIds1(dataArr1.map((item) => item.entityId));
        },
      )
      .finally(() => setLoading(false));
  }, [fetch, connection, params.id]);

  const addTeam = useCallback(
    (selectedValue1: any) => {
      setLoading(true);
      const items = userGroupTeamMembers
        ?.filter((item) => item?.entityId !== selectedValue1?.id)
        .map((item) => ({
          entityId: item?.entityId,
          type: 'teamMember',
        }));
      const items2 = userGroupUser.map((item) => ({
        entityId: item?.entityId,
        type: 'user',
      }));
      const items3 = userGroupTeamLeaders
        ?.filter((item) => item?.entityId !== selectedValue1?.id)
        .map((item) => ({
          entityId: item?.entityId,
          type: 'teamLead',
        }));
      const users = [
        ...items,
        ...items2,
        ...items3,
        {
          entityId: selectedValue1?.id,
          type: 'teamMember',
        },
        {
          entityId: selectedValue1?.id,
          type: 'teamLead',
        },
      ];
      connection
        .patch(`user-group/${params.id}/members`, {
          users,
        })
        .then(() => {
          setFetch(!fetch);
          setLoading(false);
          setSelectedValue(undefined);
          setModalVisible(false);
        });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [userGroupTeamMembers, userGroupUser, userGroupTeamLeaders, connection, params.id, fetch],
  );

  const setCustomValues = useCallback(
    (selectedValue: any, type: string) => {
      setLoading(true);
      const items = userGroupTeamMembers
        ?.filter((item) => item?.entityId !== selectedValue?.id || type !== 'teamMember')
        .map((item) => ({
          entityId: item?.entityId,
          type: 'teamMember',
        }));
      const items2 = userGroupUser
        ?.filter((item) => item?.entityId !== selectedValue?.id || type !== 'user')
        .map((item) => ({
          entityId: item?.entityId,
          type: 'user',
        }));
      const items3 = userGroupTeamLeaders
        ?.filter((item) => item?.entityId !== selectedValue?.id || type !== 'teamLead')
        .map((item) => ({
          entityId: item?.entityId,
          type: 'teamLead',
        }));
      const users = [
        ...items,
        ...items2,
        ...items3,
        {
          entityId: selectedValue?.entityId,
          type: type,
        },
      ];
      connection
        .patch(`user-group/${params.id}/members`, {
          users,
        })
        .then(() => {
          setFetch(!fetch);
          setLoading(false);
          setSelectedValue(undefined);
          setModalVisible(false);
        });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [userGroupTeamMembers, userGroupUser, userGroupTeamLeaders, connection, params.id, fetch],
  );

  // const setUserValues = useCallback(
  //   (selectedValue: any, type: string) => {
  //     setLoading(true);
  //     const items = userGroupTeamMembers.map((item) => ({
  //       entityId: item?.entityId,
  //       type: 'teamMember',
  //     }));
  //     const items2 = userGroupUser.map((item) => ({
  //       entityId: item?.entityId,
  //       type: 'user',
  //     }));
  //     const items3 = userGroupTeamLeaders.map((item) => ({
  //       entityId: item?.entityId,
  //       type: 'teamLead',
  //     }));
  //     const users = [...items, ...items2, ...items3];
  //     connection
  //       .patch(`user-group/${params.id}/members`, {
  //         users,
  //       })
  //       .then(() => {
  //         setFetch(!fetch);
  //         setLoading(false);
  //         setSelectedValue(undefined);
  //         setModalVisible(false);
  //       });
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   },
  //   [userGroupTeamMembers, userGroupUser, userGroupTeamLeaders, connection, params.id, fetch],
  // );

  const search = useCallback(
    (query: any, pagination: DataTablePagination) => {
      setLoading(true);
      connection
        .get('users', { ...pagination, ...query })
        .then((value) => {
          setTableData(value.data);
          setTotal(value.total);
        })
        .finally(() => setLoading(false));
    },
    [connection],
  );

  const showDeleteConfirm = useCallback(() => {
    confirm({
      title: `Deleting Internal Customer !`,
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure delete this Internal Customer?`,
      okText: 'Yes,Delete!',
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onOk() {
        let internalUsers: any[] = [];
        let internalTeamLead: any[] = [];
        let internalTeamMember: any[] = [];
        if (userGroupType === 'user') {
          internalUsers = userGroupUser.filter((item) => item?.entityId !== selectedValue?.id);
          internalTeamLead = userGroupTeamLeaders;
          internalTeamMember = userGroupTeamMembers;
        } else if (userGroupType === 'teamMember') {
          internalTeamMember = userGroupTeamMembers.filter(
            (item) => item?.entityId !== selectedValue?.id,
          );
          internalTeamLead = userGroupTeamLeaders;
          internalUsers = userGroupUser;
        } else if (userGroupType === 'teamLead') {
          internalTeamLead = userGroupTeamLeaders.filter(
            (item) => item?.entityId !== selectedValue?.id,
          );
          internalUsers = userGroupUser;
          internalTeamMember = userGroupTeamMembers;
        }
        const users: any[] = [];
        for (const item of internalUsers) {
          users.push({
            entityId: item?.entityId,
            type: 'user',
          });
        }
        for (const item of internalTeamMember) {
          users.push({
            entityId: item?.entityId,
            type: 'teamMember',
          });
        }
        for (const item of internalTeamLead) {
          users.push({
            entityId: item?.entityId,
            type: 'teamLead',
          });
        }
        connection
          .patch(`user-group/${params.id}/members`, {
            users,
          })
          .then(() => {
            setFetch(!fetch);
            setLoading(false);
            setSelectedValue(undefined);
            setModalVisible(false);
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [
    selectedValue,
    userGroupTeamMembers,
    userGroupType,
    connection,
    params.id,
    userGroupUser,
    userGroupTeamLeaders,
    fetch,
  ]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title={`${decodeURIComponent(params?.name)}`}
        subTitle="Manage Group Members"
        onBack={() => history1.goBack()}
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <Spin spinning={loading}>
            <div className="teams-view">
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                <Row
                  style={{
                    alignItems: 'center',
                    marginTop: 20,
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}>
                  <Space>
                    <Typography.Title level={5}>Group Members</Typography.Title>
                    <TeamOutlined style={{ color: 'black', fontSize: 20 }} />
                  </Space>
                </Row>
                <Divider style={{ marginTop: 0, marginBottom: 20 }} />
              </div>
              <div style={{ marginRight: 20, marginLeft: 20 }}>
                <Typography.Title level={5}>Teams Members</Typography.Title>
                <Select
                  style={{ display: 'block' }}
                  placeholder="Select Team"
                  onChange={(value: number) => {
                    const item = teamSet.find((team) => team.id === value);
                    if (item) {
                      addTeam(item);
                      setSelectedValue(undefined);
                    }
                  }}
                  value={selectedValue?.value}>
                  {teamSet
                    ?.filter((e) => e.id !== +params.id)
                    .filter((e) => !internalCustomerIds.some((e2) => e.id === e2))
                    .map((value: any, index) => (
                      <Select.Option key={index} value={value.id}>
                        {value.value}
                      </Select.Option>
                    ))}
                </Select>
                <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                <Table dataSource={teams} columns={columns1} pagination={false} />
                <Typography.Title level={5} style={{ marginTop: '3%' }}>
                  Users
                </Typography.Title>
                <AutoCompleteInput
                  mode={'multiple'}
                  style={{ width: '100%' }}
                  value={userGroupUser.map((e) => e.name)}
                  values={userSet
                    ?.filter((e) => e.id !== +params.id)
                    .filter((e) => !internalCustomerIds1.some((e2) => e.id === e2))
                    .map((e) => ({
                      id: e.entityId,
                      image: e.image ?? '',
                      value: e.value,
                    }))}
                  itemView={(value: any) => (
                    <Space>
                      <UserAvatar src={value?.image} />
                      {value?.value}
                    </Space>
                  )}
                  placeholder="Select Team"
                  onChange={(value: any) => {
                    const item = userSet.find((user) => user.id === value);
                    if (item) {
                      setCustomValues({ entityId: item.id }, 'user');
                    }
                  }}
                />
                <Select
                  style={{ display: 'block' }}
                  placeholder="Select User"
                  onChange={(value: number) => {
                    const item = userSet.find((user) => user.id === value);
                    if (item) {
                      setCustomValues({ entityId: item.id }, 'user');
                    }
                  }}
                  value={selectedValue?.value}>
                  {userSet
                    ?.filter((e) => e.id !== +params.id)
                    .filter((e) => !internalCustomerIds1.some((e2) => e.id === e2))
                    .map((value: any, index) => (
                      <Select.Option key={index} value={value.id}>
                        {value.value}
                      </Select.Option>
                    ))}
                </Select>
                <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                <Table dataSource={userGroupUser} columns={columns} pagination={false} />
              </div>

              <div style={{ marginRight: 20, marginLeft: 20, marginTop: 30 }}>
                <DataTable<Employee>
                  // rowKey={'id'}
                  loading={loading}
                  columns={columns2}
                  dataSource={tableDate}
                  onPaginationChange={(p) => {
                    setPagination(p);
                    if (pagination.page !== p.page || pagination.size !== p.size) {
                      search('', p);
                    }
                  }}
                  dtPagination={pagination}
                  total={total}
                />
              </div>
            </div>
            <Modal
              open={modalVisible}
              onCancel={() => {
                setSelectedValue(undefined);
                setModalVisible(false);
              }}
              footer={
                <Row>
                  <Button
                    danger
                    onClick={() => showDeleteConfirm()}
                    style={{
                      display: selectedValue ? 'flex' : 'none',
                    }}>
                    Delete
                  </Button>
                  <div style={{ flex: 1 }}>
                    <Button
                      onClick={() => {
                        setSelectedValue(undefined);
                        setModalVisible(false);
                      }}>
                      Cancel
                    </Button>
                  </div>
                </Row>
              }
              destroyOnClose>
              <div style={{ marginLeft: 20, marginRight: 20 }}>
                <Row style={{ alignItems: 'center', marginTop: 20 }}>
                  <Space>
                    <Typography.Title level={5}>
                      {userGroupType === 'teamMember'
                        ? 'Team Member'
                        : userGroupType === 'user'
                        ? 'User'
                        : userGroupType === 'teamLead'
                        ? 'Team Lead'
                        : ''}
                    </Typography.Title>
                  </Space>
                </Row>
                <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                <Col span={15} style={{ marginBottom: 20 }}>
                  <Typography>{selectedValue?.value}</Typography>
                </Col>
              </div>
            </Modal>
          </Spin>
        </WebUxPageItem>
      </WebUxPageContent>
    </WebUxPage>
  );
};
